module.exports = __webpack_public_path__ + "static/media/en.0cc73d2c.png";